import eyeIcon from './../Assets/icons/eye 1.svg'
import editIcon from './../Assets/icons/Un-Checkbox.svg'

export const TABLE_HEADERS = [
    // "Sr. No.",
    "Source Name",
    "Description",
    "Status",
    "Action"
  ];
  

  
  export const keyMapping = {
    // "Sr. No.": "Sr No.",
    "Source Name": "source_name",
    "Description": "source_desc",
    
    "Status": "status",
    "Action": [
        { type: "edit", icon: editIcon, label: "Edit" },
        
      ]
  };